import { render, staticRenderFns } from "./Mentorship.vue?vue&type=template&id=7a99915e"
import script from "./Mentorship.vue?vue&type=script&lang=js"
export * from "./Mentorship.vue?vue&type=script&lang=js"
import style0 from "./Mentorship.vue?vue&type=style&index=0&id=7a99915e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports